var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"SkuList"}},_vm._l((_vm.skus),function(sku){return _c('div',{staticClass:"SkuListItem"},[_c('a',{attrs:{"href":"#"}},[_vm._v(_vm._s(sku))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }